module.exports = __webpack_public_path__ + "img/color_act.6725d514.png";